import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IOrderBumpState } from "./model";
import { ORDER_BUMP_FEATURE_KEY } from "./reducer";

export const orderBumpFeatureState = createFeatureSelector<IOrderBumpState>(ORDER_BUMP_FEATURE_KEY);

export const selectIsLoadingCustomerInfo = createSelector(orderBumpFeatureState, (state) => state.loadingCustomerInfo);

export const selectIsLoading = createSelector(orderBumpFeatureState, (state) => state.loading);

export const selectCreditCard = createSelector(orderBumpFeatureState, (state) => state.creditCard);

export const selectedItems = createSelector(orderBumpFeatureState, (state) => state.selectedProducts);

export const selectTotal = createSelector(orderBumpFeatureState, (state) => state.total);

export const selectInstallmentTotal = createSelector(orderBumpFeatureState, (state) => state.installmentTotal);

export const selectMaxNumberOfInstallments = createSelector(
    orderBumpFeatureState,
    (state) => state.maxNumberOfInstallments
);

export const selectDiscount = createSelector(orderBumpFeatureState, (state) => state.discount);

export const selectDiscountVoucher = createSelector(orderBumpFeatureState, (state) => state.discountVoucher);

export const selectPaymentMethod = createSelector(orderBumpFeatureState, (state) => state.paymentMethod);
